import React from 'react';
import { Box } from '@mui/material';
import TopBar from './TopBar';
import BottomNavBar from './BottomNavBar';
import { BOTTOM_NAV_HEIGHT, getTopBarHeight } from './layoutSizes';

const MainLayout = ({
  children,
  title,
  showFilter,
  onFilterClick,
  activeFilterCount,
  showSearch,
  onSearch,
  searchPlaceholder,
  searchFooter,
  topBarActions,
}) => {
  // O TopBar é fixo no mobile: o conteúdo desce a altura dele e sobe a do BottomNavBar.
  // ponytail: TopBar sticky no mobile eliminaria esse cálculo
  const topBarHeight = getTopBarHeight({ showSearch, hasSearchFooter: Boolean(searchFooter) });

  return (
    <Box
      sx={(theme) => ({
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        // DESKTOP LAYOUT: height auto, let the parent panel control scrolling
        [theme.breakpoints.up('md')]: {
          minHeight: 'unset',
        },
      })}
    >
      <TopBar
        title={title}
        showFilter={showFilter}
        onFilterClick={onFilterClick}
        activeFilterCount={activeFilterCount}
        showSearch={showSearch}
        onSearch={onSearch}
        searchPlaceholder={searchPlaceholder}
        searchFooter={searchFooter}
        actions={topBarActions}
      />

      <Box
        component="main"
        sx={(theme) => ({
          flexGrow: 1,
          marginTop: `${topBarHeight}px`,
          marginBottom: `${BOTTOM_NAV_HEIGHT}px`,
          minHeight: `calc(100vh - ${topBarHeight + BOTTOM_NAV_HEIGHT}px)`,
          // DESKTOP LAYOUT: TopBar is sticky (in-flow), so no top offset needed; no bottom nav
          [theme.breakpoints.up('md')]: {
            marginTop: 0,
            marginBottom: 0,
          },
        })}
      >
        {children}
      </Box>

      <BottomNavBar />
    </Box>
  );
};

export default MainLayout;
